function sliceStringWithDots(title, length) {
  let formatted = title;
  if (title && title.length > (length-1)) {
    formatted = `${title.slice(0, length)}...`;
  }
  return formatted;
}

export default sliceStringWithDots;
